import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { isNumber } from 'lodash';

import { getProviderByUuid } from 'src/modules/providers/selectors/providersSelectors';
import { SessionSlot } from 'src/modules/videoSessions/models/videoSessions';
import { SessionReview } from 'src/modules/payments/components/SessionReview';
import { CostEstimation } from 'src/generated/webapp_gql';
import type { CoachingVisit } from 'src/modules/videoSessions/rematchModels/videoSessions';
import { captureException } from 'src/shared/helpers/captureException';

type Props = {
    providerUuid?: string;
    session: CoachingVisit;
    sessionSlot?: SessionSlot;
    costEstimation?: CostEstimation;
    onboardingMode?: boolean;
};

export const DirectSessionReview: FC<Props> = ({
    onboardingMode,
    costEstimation,
    providerUuid,
    sessionSlot,
    session,
}) => {
    const provider = useSelector(getProviderByUuid(providerUuid || ''));

    if (!provider) {
        captureException(new Error('[SessionReviewPage] Could not find provider object'), {
            provider_uuid: providerUuid,
        });

        return <Redirect to="/dashboard" />;
    }

    if (!sessionSlot || !isNumber(costEstimation?.patientResponsibility)) {
        return <Redirect to="/dashboard" />;
    }

    return (
        <SessionReview
            chargeAmount={costEstimation?.patientResponsibility}
            costEstimation={costEstimation}
            state={session.state}
            dataTestid="DirectSessionReview.TestID"
            onboardingMode={onboardingMode}
            provider={provider}
            sessionUuid={session.uuid}
            start={sessionSlot.start}
            end={sessionSlot.end}
        />
    );
};
